import React, { FC, useState, Fragment, useRef, useEffect, useMemo, useLayoutEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { restaurantCenter, restaurantConfig, orderMobx, storeMobx, cartMobx, productMobx } from 'restaurant'
import { PhoneModal, BagIcon, GroupBuyStatus } from 'components'
import { TipModal, Advert as MenuAdvert, Icon, ProductImage } from '@cps'
import { store, classNames, format, uuid, ddayjs, toPriceLittleCurrency } from '@dt/fe-utils'

import './index.scss'

interface IProps {
}

const { toPrice } = format

const Result: FC<IProps> = () => {
  const viewOrder = orderMobx.viewOrder
  const viewDetailList = orderMobx.viewDetailList
  return (
    <div className='refund-product-list'>
      {
        viewDetailList.map((item: any, index: number) => {
          return (
            <div className={classNames('product-item-wrap', { 'is-refund': item.cnt === 0 })} key={`${item.id}_${index}`}>
              {['dc', 'mall'].includes(viewOrder.ordersType) && <ProductImage color={!item.pic ? item.productNo : ''} width={64} imgSrc={item.pic} />}
              <div className='product-content-wrapper'>
                <div className='product-item'>
                  <div className='name'>
                    <p className='name-txt'>{item.name} {item.cardNo ? item.cardNo : ''} {!!item.isTogo && !['pickup', 'delivery'].includes(viewOrder.eatType) && <BagIcon size='small' />}</p>
                    {!!item.optionHtml && <p className='option-txt' dangerouslySetInnerHTML={{ __html: item.optionHtml }} />}
                    {!!item.remark && (<p className='note'>{i18n.t('common.note')}: {item.remark}</p>)}
                  </div>
                  <div className='amount'>
                    <div className='price'>{toPrice(item.cardType === 'giftcard' ? item.balanceRechargeChange : item.totalPrice)}</div>
                    {item.cnt === 0 ? (<span>{i18n.t('checkout.refunded')}</span>) : ''}
                    <div className='count'>x{item.cnt}</div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }
      {
        !viewDetailList.length && <div className='no-product-txt'>{i18n.t('result.noProducts')}</div>
      }
    </div>
  )
}

export default observer(Result)
